import type { ModelType } from "../types/ModelType";

/**
 * Folds a fresh read of the project's model rows into the list the settings page is editing, taking
 * only what the Speckle model sync writes (RTLCA-5721): the row id (a Save re-inserts the rows), the
 * Speckle model id, the version and its pull time. `isActive` is the reader's to change and is left as
 * it stands, saved or not. Rows the list lacks are appended as they came — the sync's imports, inactive
 * by design — and returned so the caller can keep its baseline honest. Matched by name, case-insensitively:
 * the sync's own join key. Nothing is removed; a sync never deletes.
 */
export const mergeModelSyncState = (current: ModelType[], fresh: ModelType[]): ModelType[] => {
  const appended: ModelType[] = [];
  for (const freshModel of fresh) {
    const model = current.find((candidate) => candidate.name.toLowerCase() === freshModel.name.toLowerCase());
    if (!model) {
      current.push(freshModel);
      appended.push(freshModel);
      continue;
    }
    model.id = freshModel.id;
    model.streamId = freshModel.streamId;
    model.speckleModelId = freshModel.speckleModelId;
    model.commitId = freshModel.commitId;
    model.commitPulledDateTime = freshModel.commitPulledDateTime;
    model.referencedObjectId = freshModel.referencedObjectId;
  }
  return appended;
};
